import script from "./sw-item-type.vue?vue&type=script&setup=true&lang=js"
export * from "./sw-item-type.vue?vue&type=script&setup=true&lang=js"

import "./sw-item-type.vue?vue&type=style&index=0&id=8099caee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8099caee"]])

export default __exports__